import { CalendarDays, ChevronDown, Cloud, FolderDown, ListChecks, ShieldCheck } from 'lucide-react'

const faqs = [
  {
    question: '¿Puedo seleccionar sólo una fecha o un intervalo concreto?',
    answer: 'Sí. Puedes elegir todo tu historial, contenido anterior a una fecha predefinida o un rango personalizado con fecha inicial y final. La selección se conserva en este navegador y se aplica a los filtros cuando abres el espacio de copia.',
  },
  {
    question: '¿Dónde quedan mis archivos?',
    answer: 'La copia principal se descarga desde Google a la carpeta que tú autorizas: ordenador, disco USB o NAS montado. libregoo no recibe ese contenido cuando eliges sólo la copia local. Si añades nube, la segunda réplica se almacena en Amazon S3 conforme a la información legal y de precio que se te muestra antes de activarla.',
  },
  {
    question: '¿Qué ocurre si prefiero una copia en la nube?',
    answer: 'La copia cloud se almacena en Amazon S3 y permanece disponible mientras el servicio de nube esté activo. Tras analizar el volumen te mostramos el coste antes de transferir nada. No vendemos ni analizamos los archivos; tampoco afirmamos cifrado de extremo a extremo mientras no exista una clave exclusiva que controles tú.',
  },
  {
    question: '¿libregoo puede borrar o modificar mi cuenta Google?',
    answer: 'No. Las conexiones de Drive y Gmail se diseñan con permiso de solo lectura. La aplicación prepara una copia; no envía correos, no elimina archivos ni modifica tu cuenta.',
  },
  {
    question: '¿Puedo hacer una copia completa de Google Fotos?',
    answer: 'Google no permite que una aplicación descargue automáticamente toda una fototeca existente. Para una biblioteca completa, libregoo prepara una importación local del archivo oficial que tú eliges. Para fotos puntuales se utilizará el selector oficial de Google Fotos.',
  },
]

export function InfoSections() {
  return <>
    <section className="how-it-works" id="como-funciona">
      <div className="info-section-intro">
        <p className="eyebrow">CÓMO FUNCIONA</p>
        <h2>Tu copia, sin perder el control.</h2>
        <p>La configuración te deja decidir qué conservar y dónde, antes de que se descargue un solo archivo.</p>
      </div>
      <div className="how-flow">
        <article>
          <span className="how-icon"><CalendarDays size={21} /></span>
          <h3>Elige qué y cuándo</h3>
          <p>Selecciona Gmail, Drive o Fotos. Guarda todo, lo anterior a una fecha o un intervalo exacto.</p>
        </article>
        <article>
          <span className="how-icon"><FolderDown size={21} /></span>
          <h3>Decide el orden y destino</h3>
          <p>Organiza por año, mes y tipo; después autoriza tu carpeta local, disco USB o NAS montado.</p>
        </article>
        <article>
          <span className="how-icon"><Cloud size={21} /></span>
          <h3>Añade nube sólo si quieres</h3>
          <p>La copia cloud se guarda en Amazon S3 y se cotiza después del análisis, antes de activar transferencias.</p>
        </article>
        <article>
          <span className="how-icon"><ShieldCheck size={21} /></span>
          <h3>Revisa el resultado</h3>
          <p>Recibes una copia local organizada y un manifiesto que registra archivos, rutas e incidencias.</p>
        </article>
      </div>

      <aside className="cleanup-callout" id="limpieza" aria-labelledby="cleanup-title">
        <span className="cleanup-icon"><ListChecks size={28} /></span>
        <div className="cleanup-copy">
          <p className="eyebrow">LIMPIEZA SEGURA</p>
          <h3 id="cleanup-title">Haz limpieza de forma ordenada.</h3>
          <p>Primero proteges y verificas tu copia. Después revisas el espacio que podrías recuperar y decides personalmente qué eliminar en Google.</p>
          <div className="cleanup-steps" aria-label="Proceso de limpieza segura">
            <span><b>1</b> Crea tu copia</span>
            <span><b>2</b> Verifica el resultado</span>
            <span><b>3</b> Decide qué liberar</span>
          </div>
        </div>
        <a className="button button-primary cleanup-cta" href="/copia">Preparar una limpieza segura</a>
      </aside>
    </section>

    <section className="faq-section" id="preguntas">
      <div className="info-section-intro">
        <p className="eyebrow">PREGUNTAS FRECUENTES</p>
        <h2>Lo importante, explicado sin letra pequeña.</h2>
      </div>
      <div className="faq-list">
        {faqs.map((faq) => <details key={faq.question}>
          <summary>{faq.question}<ChevronDown size={18} /></summary>
          <p>{faq.answer}</p>
        </details>)}
      </div>
    </section>
  </>
}
